<template>
    <v-row v-if="show" justify="center">
        <v-dialog
                v-model="dialog"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                        color="blue-grey darken-4"
                        text
                        small
                        class="edit-inner-block"
                        v-bind="attrs"
                        v-on="on"
                >
                    <v-icon>
                        mdi-pencil
                    </v-icon>
                </v-btn>
            </template>
            <v-card>
                <v-toolbar
                        dark
                        color="black"
                >
                    <v-btn
                            icon
                            dark
                            @click="dialog = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Inner Block Options</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn
                                dark
                                text
                                @click="dialog = false"
                        >
                            Close Options
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <h2 class="headline mb-5">
                                Background Color
                            </h2>
                            <blocks-functions-color-picker :item="item"></blocks-functions-color-picker>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <h2 class="headline mb-5">
                                Padding
                            </h2>
                        </v-col>
                        <v-col cols="12" sm="12" md="3">
                            <v-slider
                                    v-model="item.pt"
                                    label="Top"
                                    :thumb-color="'black'"
                                    track-color="grey"
                                    thumb-label="always"
                                    min="0"
                                    max="12"
                            ></v-slider>
                        </v-col>
                        <v-col cols="12" sm="12" md="3">
                            <v-slider
                                    v-model="item.pb"
                                    label="Bottom"
                                    :thumb-color="'black'"
                                    track-color="grey"
                                    thumb-label="always"
                                    min="0"
                                    max="12"
                            ></v-slider>
                        </v-col>
                        <v-col cols="12" sm="12" md="3">
                            <v-slider
                                    v-model="item.pr"
                                    label="Right"
                                    :thumb-color="'black'"
                                    track-color="grey"
                                    thumb-label="always"
                                    min="0"
                                    max="12"
                            ></v-slider>
                        </v-col>
                        <v-col cols="12" sm="12" md="3">
                            <v-slider
                                    v-model="item.pl"
                                    label="Left"
                                    :thumb-color="'black'"
                                    track-color="grey"
                                    thumb-label="always"
                                    min="0"
                                    max="12"
                            ></v-slider>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                            <h2 class="headline mb-5">
                                Margin
                            </h2>
                        </v-col>
                        <v-col cols="12" sm="12" md="3">
                            <v-slider
                                    v-model="item.mt"
                                    label="Top"
                                    :thumb-color="'black'"
                                    track-color="grey"
                                    thumb-label="always"
                                    min="0"
                                    max="12"
                            ></v-slider>
                        </v-col>
                        <v-col cols="12" sm="12" md="3">
                            <v-slider
                                    v-model="item.mb"
                                    label="Bottom"
                                    :thumb-color="'black'"
                                    track-color="grey"
                                    thumb-label="always"
                                    min="0"
                                    max="12"
                            ></v-slider>
                        </v-col>
                        <v-col cols="12" sm="12" md="3">
                            <v-slider
                                    v-model="item.mr"
                                    label="Right"
                                    :thumb-color="'black'"
                                    track-color="grey"
                                    thumb-label="always"
                                    min="0"
                                    max="12"
                            ></v-slider>
                        </v-col>
                        <v-col cols="12" sm="12" md="3">
                            <v-slider
                                    v-model="item.ml"
                                    label="Left"
                                    :thumb-color="'black'"
                                    track-color="grey"
                                    thumb-label="always"
                                    min="0"
                                    max="12"
                            ></v-slider>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <h2 class="headline">
                                Column Sizes
                            </h2>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" lg="4">
                            <h3 class="body-1 font-weight-bold mb-12">
                                Size at Small
                            </h3>
                            <v-slider
                                    v-model="item.sm"
                                    :label="item.sm.toString()"
                                    :thumb-color="'black'"
                                    track-color="grey"
                                    thumb-label="always"
                                    min="0"
                                    max="12"
                            ></v-slider>
                        </v-col>

                        <v-col cols="12" sm="4" md="4" lg="4">
                            <h3 class="body-1 font-weight-bold mb-12">
                                Size at Medium
                            </h3>
                            <v-slider
                                    v-model="item.md"
                                    :label="item.md.toString()"
                                    :thumb-color="'black'"
                                    track-color="grey"
                                    thumb-label="always"
                                    min="0"
                                    max="12"
                            ></v-slider>
                        </v-col>

                        <v-col cols="12" sm="4" md="4" lg="4">
                            <h3 class="body-1 font-weight-bold mb-12">
                                Size at Large
                            </h3>
                            <v-slider
                                    v-model="item.lg"
                                    :label="item.lg.toString()"
                                    :thumb-color="'black'"
                                    track-color="grey"
                                    thumb-label="always"
                                    min="0"
                                    max="12"
                            ></v-slider>
                        </v-col>
                    </v-row>
                    <v-row class="mt-12">
                        <v-col cols="12">
                            <h2 class="headline">
                                Column Offset Sizes
                            </h2>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" lg="4">
                            <h3 class="body-1 font-weight-bold mb-12">
                                Offset at Small
                            </h3>
                            <v-slider
                                    v-model="item.sm_offset"
                                    :label="item.sm_offset.toString()"
                                    :thumb-color="'black'"
                                    track-color="grey"
                                    thumb-label="always"
                                    min="0"
                                    max="12"
                            ></v-slider>
                        </v-col>

                        <v-col cols="12" sm="4" md="4" lg="4">
                            <h3 class="body-1 font-weight-bold mb-12">
                                Offset at Medium
                            </h3>
                            <v-slider
                                    v-model="item.md_offset"
                                    :label="item.md_offset.toString()"
                                    :thumb-color="'black'"
                                    track-color="grey"
                                    thumb-label="always"
                                    min="0"
                                    max="12"
                            ></v-slider>
                        </v-col>

                        <v-col cols="12" sm="4" md="4" lg="4">
                            <h3 class="body-1 font-weight-bold mb-12">
                                Offset at Large
                            </h3>
                            <v-slider
                                    v-model="item.lg_offset"
                                    :label="item.lg_offset.toString()"
                                    :thumb-color="'black'"
                                    track-color="grey"
                                    thumb-label="always"
                                    min="0"
                                    max="12"
                            ></v-slider>
                        </v-col>
                    </v-row>

                </v-container>
                <v-divider></v-divider>
                {{ item }}
            </v-card>
        </v-dialog>

    </v-row>
</template>

<script>
  import BlocksFunctionsColorPicker from "@/components/Blocks/Functions/ColorPicker.vue";
    export default {
        props: {
            item: Object
        },
        components: {BlocksFunctionsColorPicker},
        data() {
            return {
              show: false,
                dialog: false
            }
        }
    }
</script>

<style lang="scss">
    .edit-inner-block {
        text-shadow: 0px 0px 2px #FFFFFF;
        font-size: 12px;
        position: absolute;
        top: 0;
        right: 0;
    }
    .add_inner_block {
        text-shadow: 0px 0px 2px #FFFFFF;
        position: absolute;
        bottom: 0;
        right: 0;
        left:0;
        margin:auto;
    }
</style>
